import { atom } from 'jotai'

const childrenOrdersOpenState = atom<boolean>(false)
const childrenOrdersErrorsOpenState = atom<boolean>(false)

export { childrenOrdersOpenState, childrenOrdersErrorsOpenState }
